import { Pipe, PipeTransform } from '@angular/core';
// import { first } from 'rxjs/operators';

@Pipe({ name: 'isEmpty' })
export class IsEmpty implements PipeTransform {
  transform(value, args): any {
    if (!value) {
        return '-';
    } else {
        return value;
    }
  }
}
